<template>
  <div class="setting">
    <CDNbreadcrumbs :items="items" />
    <!--  -->
    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <!-- <el-tab-pane label="配置" name="first">
        <prodConfig />
    </el-tab-pane> -->
    <el-tab-pane :label="$t('product.cache')" name="first">
      <CacheSetting :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.strategy')" name="second">
      <CeNueSetting :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
    <el-tab-pane :label="$t('allDomain.originSettings')" name="third">
      <OriginSite :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
    
    <el-tab-pane :label="$t('allDomain.visitLog')" name="four">
      <visitLog :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>

    <el-tab-pane :label="$t('allDomain.maintain')" name="five">
      <maintain :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>

    <el-tab-pane :label="$t('allDomain.config')" name="six">
      <childDomainConfig :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>

    <el-tab-pane :label="$t('allDomain.cert')" name="seven">
      <childDomainCert :domainHost="domainHost" :serverJson="host_json_server" />
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>

<script>
import CacheSetting from '@/views/products/CacheSetting.vue';
import CeNueSetting from '@/views/products/CeNueSetting2.vue';
// import prodConfig from '@/views/products/prodConfig.vue';
import OriginSite from '@/views/dev/OriginSite.vue';
import visitLog from '@/views/dev/visitLog.vue';
import maintain from '@/views/dev/maintain.vue';
import childDomainConfig from '@/views/dev/childDomainConfig.vue';
import childDomainCert from '@/views/dev/childDomainCert.vue';
import { childDomainDetail } from '@/service/requestRes';

export default {
    props: {
        domainHost: String,
        childDomainId: Number,
    },
  components: {
    CacheSetting,
    CeNueSetting,
    OriginSite,
    visitLog,
    maintain,
    childDomainConfig,
    childDomainCert,
    // prodConfig,
  },
  data() {
    return {
      activeName: 'first',
      host_json_server: '',
    };
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('product.productlist'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('product.cache'),
        },
      ];
    },
  },
  mounted() {
    this.getChildDomainDetail();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getChildDomainDetail() {
      childDomainDetail(this.childDomainId).then(res => {
           const { data, code, msg } = res || {};
        if (code === 1) {
          this.host_json_server = data.host_json_server || '';
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
  .setting {
    background-color: white;
    padding: 24px;
  }
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
